module.exports = __webpack_public_path__ + "static/freedom-8b29dde49291eef81909bc5060e4a6bd.jpg";